// A narrow bridge; authentication tokens never cross it.
export function isNativeApp() {
  return typeof window !== "undefined" && !!window.webkit?.messageHandlers?.salesmachineAuth;
}
export function nativeQuery() { return isNativeApp() ? "?native=ios" : ""; }
export function openOAuth(url) {
  const parsed = new URL(url);
  if (parsed.protocol !== "https:" || !["login.microsoftonline.com", "accounts.google.com"].includes(parsed.hostname)) {
    throw new Error("Ungültige Anmeldeadresse.");
  }
  if (isNativeApp()) window.webkit.messageHandlers.salesmachineAuth.postMessage({ url: parsed.href });
  else window.location.assign(parsed.href);
}
